"use strict";
module.exports = require('../../module.compiled').vendored['react-ssr'].ReactJsxRuntime;

//# sourceMappingURL=react-jsx-runtime.js.map